import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Halima from "../../../assets/shortlist_23/halima.png";
import Chinonso from "../../../assets/shortlist_23/chinonso.png";
import Uche from "../../../assets/shortlist_23/uche.png";
import Prosper from "../../../assets/shortlist_23/prosper.png";

const healthNominees = [
  {
    name: "Halima Layeni",
    title: "Life After Abuse Foundation/Men's Mental Health Advocacy",
    imgpath: Halima,
  },
  {
    name: "Dr Chinonso Fidelis Egemba",
    title: "Aproko Doctor/100K plus",
    imgpath: Chinonso,
  },
  {
    name: "Uche Udekwe",
    title: "NATAL CARES/Project Natal Cares",
    imgpath: Uche,
  },
  {
    name: "Dr. Prosper Okonkwo",
    title: "APIN Health Initiative/Helping women thrive",
    imgpath: Prosper,
  },
];

const HealthNominees = () => {
  return (
    <Grid
      item
      xs={12}
      md={12}
      marginTop={{ xs: "10%", sm: "3%" }}
      data-aos={"fade-up"}
    >
      <Typography
        variant={"h5"}
        fontWeight={400}
        paddingBottom={"2%"}
        color={"#049593"}
      >
        Award for Health Activism (Shortlisted Nominees)
      </Typography>
      <Grid item xs={12} md={12} display={"flex"} flexWrap={"wrap"}>
        {healthNominees.map((nominate, index) => {
          const { name, title, imgpath } = nominate;
          return (
            <Grid
              key={index}
              item
              xs={12}
              md={3}
              marginBottom={{ xs: "7%", sm: "2%" }}
            >
              <Card
                sx={{
                  maxWidth: 260,
                  height: "100%",
                  borderTop: "10px solid #D7A036",
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Avatar
                      alt={name}
                      src={imgpath}
                      sx={{ width: 126, height: 126 }}
                    />
                    <Typography
                      gutterBottom
                      variant="h6"
                      color={"#004165"}
                      component="div"
                      textAlign={"center"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      variant="body2"
                      fontWeight={700}
                      color="#049593"
                      paragraph
                      textAlign={"center"}
                    >
                      {title}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default HealthNominees;
